import { useSyncExternalStore } from 'react';

export function useWindowInnerWidth() {
  return useSyncExternalStore(
    (listener) => {
      window.addEventListener('resize', listener);

      return () => {
        window.removeEventListener('resize', listener);
      };
    },
    () => window.innerWidth,
  );
}
